import { Doughnut, Pie , Bar} from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import "./pieChart.scss";

function PieChart({ pieData,status,displayText }) {
  ChartJS.register(ArcElement, Tooltip, Legend);

  const CandidateStatusAvailabledata = {

  labels :[ "A","AHCTC","AHNP", "DP"],
  datasets : [
    {
      label : 'Candidates',
      data: [ pieData?.candidatestatus.NoOfResumesAvailable,pieData?.candidatestatus.NoOfResumesAvailableHCTC,pieData?.candidatestatus.NoOfResumesAvailableHNP,pieData?.candidatestatus.NoOfResumesClientDirectPayroll],
      backgroundColor: [
        'rgba(75, 192, 192, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
      ],
      borderColor: [
        'rgba(75, 192, 192, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
      ],
      borderWidth: 1,
    },
  ],
};
const CandiateStatusNeedToCalldata = {

  labels :[ "S", "TBC","CL","JD","NP","B/D"],
  datasets : [
    {
      label : 'Candidates',
      data: [pieData?.candidatestatus.NoOfResumesSourced, pieData?.candidatestatus.NoOfResumesToBeCalled, 
             pieData?.candidatestatus.NoOfResumesCallLater,pieData?.candidatestatus.NoOfResumesJDNeeded,
             pieData?.candidatestatus.NoOfResumesNotPicking,pieData?.candidatestatus.NoOfResumesBusy+pieData?.candidatestatus.NoOfResumesDisconnected],
      backgroundColor: [
        'rgba(255, 99, 219, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
      ],
      borderColor: [
        'rgb(239, 99, 255)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

const CandiateSuitabilitydata = {

  labels :[ "NS","BA","A","AA","GM"],
  datasets : [
    {
      label : 'Candidates',
      data: [pieData?.resumequalitystatus?.numnotsuitable, pieData?.resumequalitystatus?.numbelowaverage,
             pieData?.resumequalitystatus?.numaverage, pieData?.resumequalitystatus?.numaboveaverage,
             pieData?.resumequalitystatus?.numgoodmatch],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(255, 159, 64, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(255, 159, 64, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

const ResumeStatusdata = {
  labels :[ "S","IRP","TBS"],
  datasets : [
    {
      label : 'Candidates',
      data: [pieData?.resumestatus?.NoOfShared, pieData?.resumestatus?.NoOfReviewPending,
             pieData?.resumestatus?.NoOfToBeShared],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(255, 159, 64, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(255, 159, 64, 1)',
      ],
      borderWidth: 1,
    },
  ],
};
const ResumeStatusFeedbacksdata = {
  labels :[ "FBP","CFBP","SR","D","IR","SS"],
  datasets : [
    {
      label : 'Candidates',
      data: [pieData?.resumestatus?.NoOfFBPending,
             pieData?.resumestatus?.NoOfClientFBPending,pieData?.resumestatus?.NoOfScreenRejected,
             pieData?.resumestatus?.NoOfDuplicate,pieData?.resumestatus?.NoOfInterviewRejected,
             pieData?.resumestatus?.NoOfScreenSelected],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(255, 159, 64, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(255, 159, 64, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

const PieChartdata = {

  labels :[ "T", "A","CL","JD","NP","B/D","AHCTC","AHNP"],
  datasets : [
    {
      label : 'Candidate Status',
      data: [pieData?.candidatestatus.NoOfResumesSourced, pieData?.candidatestatus.NoOfResumesAvailable, pieData?.candidatestatus.NoOfResumesCallLater, pieData?.candidatestatus.NoOfResumesJDNeeded,
        pieData?.candidatestatus.NoOfResumesNotPicking, pieData?.candidatestatus.NoOfResumesBusy+pieData?.candidatestatus.NoOfResumesDisconnected,pieData?.candidatestatus.NoOfResumesAvailableHCTC,pieData?.candidatestatus.NoOfResumesAvailableHNP],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

  return (
      <div className= "pieChart-wrapper" >
        {
        displayText == "Available"?
          <>
            <Pie
            data={CandidateStatusAvailabledata}
            options={{
              plugins: {
                title: {
                  display: true,
                  text: displayText
                }
              }
             }}
            />
          </>
        :displayText == "Need to Call"?
          <> 
            <Pie
            data={CandiateStatusNeedToCalldata}
            options={{
              plugins: {
                title: {
                  display: true,
                  text: displayText
                }
              }
             }}
            />                    
          </>
        :displayText == "Suitability"?
          <>
            <Pie
            data={CandiateSuitabilitydata}
            options={{
              plugins: {
                title: {
                  display: true,
                  text: displayText
                }
              }
             }}
            />          
          </>
        :displayText == "Resume Status"?
        <>
          <Pie
          data={ResumeStatusdata}
          options={{
            plugins: {
              title: {
                display: true,
                text: displayText
              }
            }
           }}
          />          
        </>
        :displayText == "Resume Feedbacks"?
        <>
          <Pie
          data={ResumeStatusFeedbacksdata}
          options={{
            plugins: {
              title: {
                display: true,
                text: displayText
              }
            }
           }}
          />          
        </>        
        :
          <>
            <Pie
            data={PieChartdata}
            options={{
              plugins: {
                title: {
                  display: true,
                  text: displayText
                }
              }
             }}
            />
          </>    
        }
      </div>

  );
}
export default PieChart;